<template>
  <div>
    <div
      ref="cardWrapper"
      :data-prodid="item.prodID"
      :data-master-style="item.master_style"
      :data-style="item.style"
      :data-name="item.datamann_desc"
      :data-category="item.productType"
      :data-price="item.pricing.min_discount_price"
      :data-list="listName"
      :data-position="index"
      :class="{hovering: hovering}"
      class="thumbnail product-listing"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave">
      <meta
        itemprop="brand"
        content="Julianna Rae">
      <meta
        :content="item.style"
        itemprop="mpn">
      <div class="image-container">
        <div v-if="false && onSale" class="ribbon"><span class="brand">On Sale</span></div>
        <a
          :href="targetUrl"
          class="href-color-adjust"
          itemprop="url"
          @click="onProductClick">
          <img
            ref="mainImage"
            :src="imageSrc"
            :alt="item.mainImage_alttag"
            loading="lazy"
            width="292"
            height="411"
            itemprop="image">
        </a>
        <div
          v-if="item.pinterestUrl"
          class="pinterest pinterest-small">
          <a
            :href="'https://www.pinterest.com/pin/create/button/?' + item.pinterestUrl"
            target="_blank"
            rel="noopener">
            <svg><use xlink:href="#pinterest"/></svg>
          </a>
        </div>
      </div>
      <div class="caption">
        <a
          :href="targetUrl"
          class="href-color-adjust"
          @click="onProductClick">
          <div>
            <span
                class="product-name"
                itemprop="name"
                v-html="item.name || item.datamann_desc"/>
            <span v-if="newStyle" class="badge silver">New</span>
            <span v-if="newColors" class="badge silver">New Colors</span>
          </div>
            <product-price
                    class="product-price"
                    :has-sale-price="item.hasSalePrice"
                    :pricing="item.pricing"/>
          <color-count :count="item.colors.length" :sale-count="saleColorCount"/>
          <div
            v-if="item.alsoPetite"
            class="also-petite">
            Also in: Petite
          </div>
          <div
            v-if="item.alsoRegular"
            class="also-petite">
            Also in: Regular
          </div>
        </a>
        <div
          v-if="hover"
          class="extra-detail">
          <hr>
          <swatch-list
            v-if="!noColors"
            :sale-only="saleOnly"
            :colors="item.colors"
            :product-url="item.url"
            v-on:changeSwatch="changeSwatch"/>
          <div>
            <product-compare :master-style="item.master_style"/>
            <div
              v-if="item.total_reviews > 0"
              class="pull-right">
              <star-rating
                :total-reviews="item.total_reviews"
                :average-score="item.average_score"/>
            </div>
            <div class="clearfix"/>
          </div>
        </div>
        <div
          itemprop="offers"
          itemscope
          itemtype="http://schema.org/Offer">
          <meta
            :content="item.pricing.min_discount_price"
            itemprop="price">
          <meta
            itemprop="priceCurrency"
            content="USD">
          <meta
            itemprop="availability"
            content="http://schema.org/InStock">
          <meta
            itemprop="itemCondition"
            content="http://schema.org/NewCondition">
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import ColorCount from './ColorCount'
import SwatchList from './SwatchList'
import StarRating from './StarRating'
import ProductPrice from './ProductPrice'
import ProductCompare from './ProductCompare'
import { handleProductClick } from '../../module/util'

export default {
  components: {
    'color-count': ColorCount,
    'swatch-list': SwatchList,
    'star-rating': StarRating,
    'product-price': ProductPrice,
    'product-compare': ProductCompare
  },

    props: {
        item: {
            type: Object,
            default: null
        },
        listName: {
          type: String,
          default: null
        },
        index: {
            type: Number,
            default: null
        },
        noColors: {
            type: String,
            default: null
        },
        saleOnly: {
            type: Boolean,
            default: false
        },
        hover: {
            type: Number,
            default: 1
        }
    },

    data () {
        return {
            hovering: 0,
            onSale: this.item ? this.item.on_sale : false,
            newStyle: this.item ? this.item.new_style : false,
            newColors: this.item ? this.item.new_colors && !this.item.new_style : false,
            imageSrc: this.item ? this.item.listingImageUrl : null,
            targetUrl: this.item ? this.item.url + this.item.urlSelector : null,
        }
    },

    methods: {
        onProductClick () {
            handleProductClick()
        },
        changeSwatch (data) {
            this.imageSrc = data.imageSrc
            this.targetUrl = data.targetUrl
            this.onSale = data.onSale
        },
        onMouseEnter (event) {
            if (this.hover) {
                var target = event.target
                var style = window.getComputedStyle(target, null)
                target.parentNode.style.height = style.height + 'px'
                // Lazy load swatch images
                Array.from(target.querySelectorAll('img[data-hover-src]')).forEach(function (item) {
                    item.setAttribute('src', item.getAttribute('data-hover-src'))
                    item.removeAttribute('data-hover-src')
                })
                this.hovering = 1
            }
        },
        onMouseLeave (event) {
            if (this.hover) {
                this.hovering = 0
                event.target.parentNode.style.height = null
            }
        }
    },

    computed: {
        saleColorCount () {
            // TODO - support sale color count in search results
            return this.item.saleColors ? this.item.saleColors.length : 0
        }
    },
}
</script>
